<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <DashboardHeader />
    <v-row v-if="mobile()">
      <v-col
        cols="11"
        class="d-flex justify-end mt-n3 mx-auto"
      >
        <SearchBarGlobal
          :space-id="spaceId"
          :size-activities="sizeActivities"
          :size-hubs="sizeHubs"
        />
      </v-col>
    </v-row>
    <v-row v-else class="mt-n14">
      <v-col
        cols="4"
        class="mx-auto mt-n4 d-flex justify-end"
      >
        <SearchBarGlobal
          :space-id="spaceId"
          :size-activities="sizeActivities"
          :size-hubs="sizeHubs"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="hubs.length == 0 && !loadingData"
      align="center"
      class="mt-16"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <EmptyPage
          :page-text="$t('emptyHubsPageTextParticipant')"
          page-image="image2"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="hubs.length > 0 && !loadingData"
      class="mx-auto"
    >
      <v-col
        align="center"
        :cols="mobile() ? '12' : '11'"
        :class="mobile() ? '' : 'mx-auto px-0'"
      >
        <v-row align="center">
          <v-col
            v-for="item in hubs"
            :key="item.id"
            cols="12"
            sm="6"
            xl="4"
          >
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                height="280"
                data-testid="hub-card"
                rounded="xxl" 
                class="mx-auto rounded-xxl"
                :ripple="false"                        
                :class="`elevation-${hover? 8 : 2 } ${hover? 'v-card--shadow': 'v-card--flat'}`" 
                :to="'/hub/'+item.id"
              >
                <v-responsive class="rounded-b-0">
                  <v-img
                    class="rounded-t-xl"
                    :src="(item.attributes.image) ? item.attributes.image : require('../../assets/background-hub.jpg')"
                    height="120px"
                  >
                    <v-card-text class="py-5">
                      <v-row
                        no-gutters
                        class="mx-auto"
                      >
                        <v-col
                          class="d-flex align-start ml-2"
                          cols="12"
                          sm="12"
                          md="12"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-chip
                                small
                                data-testid="sharing-setting-chip"
                                color="darktext"
                                text-color="white"
                                filter-icon="mdi-equalizer-outline"
                                class="mr-4"
                                v-on="on"
                              >
                                <v-icon
                                  size="14"
                                  class="pr-1"
                                >
                                  mdi-share-variant
                                </v-icon>
                                <span v-if="item.attributes.sharing_setting == 'Restricted'">{{ $t('sharingSettingRestricted') }}</span>
                                <span v-if="item.attributes.sharing_setting == 'Open'">{{ $t('sharingSettingOpen') }}</span>
                              </v-chip>
                            </template>
                            <span v-if="item.attributes.sharing_setting == 'Restricted'">{{ $t('sharingSettingRestrictedHubTooltip') }}</span>
                            <span v-if="item.attributes.sharing_setting == 'Open'">{{ $t('sharingSettingOpenHubTooltip') }}</span>
                          </v-tooltip>
                          <v-chip
                            small
                            color="accent"
                          >
                            <span class="text-uppercase">{{ $t('hub') }}</span>
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-img>
                </v-responsive>
                <v-card-text class="pa-0">
                  <v-row no-gutters>
                    <v-col
                      cols="11"
                      sm="11"
                      md="11"
                      class="py-0"
                    >
                      <v-card-title
                        class="text-left no-break darktext--text"
                        style="line-height:inherit"
                      >
                        <v-clamp
                          autoresize
                          :max-lines="1"
                        >
                          {{ item.attributes.title }}
                        </v-clamp>
                      </v-card-title>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      class="py-0"
                    >
                      <v-card-subtitle class="text-left text-body-1 greytext--text no-break darktext--text py-0">
                        <v-clamp
                          autoresize
                          :max-lines="3"
                        >
                          {{ item.attributes.description }}
                        </v-clamp>
                      </v-card-subtitle>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <Pagination
      v-model="pageNumber"
      class="mb-16"
      circle
      :data-length="hubsInfo.total"
      :page-number="hubsInfo.currentPage"
      total-visible="5"
      :size="size"
      @input="handlePageChange"
    />
  </nav>
</template>

<script>
import i18n from '../../plugins/i18n'
import { getAllHubs } from '../../api/hubApi'
import Pagination from '../../components/Pagination'
import EmptyPage from '../../components/EmptyPage'
import VClamp from 'vue-clamp'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import AlertMessages  from '../../components/AlertMessages'
import DashboardHeader  from '../../components/DashboardHeader'
import SearchBarGlobal  from '../../components/SearchBarGlobal'

export default {
    components: {
        Pagination,
        EmptyPage,
        VClamp,
        AlertMessages,
        DashboardHeader,
        SearchBarGlobal
    },
    mixins: [repeatedMethodsMixin],

    data(){
        return{
            hubs: [],
            hubsInfo: {
              currentPage: 1,
              total: 1,
            },
            permissions: [],
            spaceId: window.$cookies.get('space_id'),
            alertMsg:'',
            alertType:'',
            alertValue:false,
            pageNumber: 1,
            size: 12,
            link: {title: '', route: '/hub/create'},
            loadingData: false
        }
    },

    async created(){
        this.loadingData = true
        await this.fetchHubs()
        this.loadingData = false
    },
    computed:{
      sizeHubs() {
        switch (this.$vuetify.breakpoint.name) {
          case 'xl': return 3
          default: return 2
        }
      },
      sizeActivities() {
        switch (this.$vuetify.breakpoint.name) {
          case 'xl': return 4
          default: return 6
        }
      },
    },
    methods:{
        handlePageChange(value){
            this.hubsInfo.currentPage = value
            this.pageNumber = value
            this.fetchHubs()
        },
        showhubPage(){
            this.$router.push({path: '/all-hubs-participant'})
        },
        showActivityPage(){
            this.$router.push({path: '/all-activities-participant'}) 
        },
        seeAll(){
            this.$router.push({path: '/dashboard-participant'}) 
        },
        async fetchHubs(){
            try {
                const response = await getAllHubs(this.spaceId, this.pageNumber, this.size)
                if(response.status){
                    if(response.status == 200) {
                        this.hubs = response.data.data
                        window.scrollTo(0,0)
                        if(response.data.meta.page){
                            this.hubsInfo = response.data.meta.page
                        }
                    }
                }
            } catch (e) {
                if(e.response){
                    if(e.response.status == 404) {
                        this.$router.push({name: 'PageNotFound'})
                    }
                    else if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }   
            }
        }
    }
}
</script>
